// Per-user persist scope for web multi-account support.
// Exported separately to avoid circular imports between store and reducers.
let _persistUserEmail = typeof window !== 'undefined' && typeof sessionStorage !== 'undefined'
  ? (sessionStorage.getItem('email') || 'default')
  : 'default';

export const getPersistUserEmail = () => _persistUserEmail;

export const setPersistUserEmail = (email) => {
  const prev = _persistUserEmail;
  _persistUserEmail = email || 'default';
};
